<template>
<div class="chapter">
<div class="inner_page">
<div id="Dedication">
<p class="ded"><a id="page_x"></a><a id="page_xi">There are two people who are always with me in my life and in my writing, my beloved wife Daisy without whom nothing would be possible, and my dear son, Michael, who is our future, and is the blood of my heart. To them, now as always, this volume is dedicated.</a></p><a id="page_xi">
</a></div><a id="page_xi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Dedication.vue?cc259222